import * as types from '../constants/ActionTypes';
import update from 'immutability-helper';

const initialState = {  
    departurePortCode: null,
    departurePortId: null,
    departurePortLavel: null,
    arrivalPortCode: null,
    arrivalPortId: null,
    arrivalPortLabel: null,

    departurePortList: [],
    arrivalPortList: [],

    startDate: null,
    endDate: null,

    isRoundTrip: false,
    
};

export default function search (state = initialState, action) {
    switch (action.type) {
        case types.SET_DEPARTURE:
            return update(state, {departurePortCode: {$set: action.portCode}, departurePortId: {$set: action.portId}, departurePortLabel: {$set: action.portLabel} })
        case types.SET_ARRIVAL:
            return update(state, {arrivalPortCode: {$set: action.portCode}, arrivalPortId: {$set: action.portId}, arrivalPortLabel: {$set: action.portLabel} })
        case types.SET_DEPARTURE_LIST:
            return update(state, {departurePortList: {$set: action.departureList} })
        case types.SET_ARRIVAL_LIST:
            return update(state, { arrivalPortList: {$set: action.arrivalList} })
        case types.SET_START_DATE:
            return update(state, { startDate: {$set: action.startDate} })
        case types.SET_END_DATE:
            return update(state, { endDate: {$set: action.endDate} })
        case types.SET_DATES:
            return update(state, { startDate: {$set: action.startDate}, endDate: {$set: action.endDate} })
        case types.SET_IS_ROUND_TRIP:
            return update(state, { isRoundTrip: {$set: action.isRoundTrip} })
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_header.js